import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { MODAL_SIZE } from '@CommonConstants';
import themes, { THEME_TYPES } from '@Styles/Themes';

import Modal from '@Components/Common/Modal';
import TX from '@Components/Common/Text';
import TextCSS from '@Components/Common/Text/Styles';
import Button from '@Components/Common/Button';
import projectTagList from './ProjectTagList';

const ProjectTagModal = ({
  isProjectTagModalVisible,
  getExistedTag,
  handleProjectTagClick,
  handleProjectTagModalVisible,
  handleProjectTagCreateCancelClick,
}) => {
  const theme = themes[THEME_TYPES.LIGHT];

  return (
    <Modal
      visible={isProjectTagModalVisible}
      size={MODAL_SIZE.BIG}
      handleCloseButtonClick={handleProjectTagModalVisible}
    >
      <InnerContainer>
        {projectTagList.map(({ category, tags }) => (
          <TagContainer key={category}>
            <TagText>{category}</TagText>

            <TagItemsContainer>
              {tags.map(tag => {
                const isSelectedProjectTag = getExistedTag(tag);

                return (
                  <TagItem key={tag} isSelected={isSelectedProjectTag} onClick={() => handleProjectTagClick(tag)}>
                    <TagItemText isSelected={isSelectedProjectTag}>{tag}</TagItemText>
                  </TagItem>
                );
              })}
            </TagItemsContainer>
          </TagContainer>
        ))}
      </InnerContainer>

      <BottomContainer>
        <Button
          text="취소"
          backgroundColor={theme.colors.ui_2}
          textColor={theme.colors.ui_on_1}
          onClick={handleProjectTagCreateCancelClick}
        />
        <Button text="적용" onClick={handleProjectTagModalVisible} />
      </BottomContainer>
    </Modal>
  );
};

ProjectTagModal.propTypes = {
  isProjectTagModalVisible: PropTypes.bool.isRequired,
  getExistedTag: PropTypes.func.isRequired,
  handleProjectTagClick: PropTypes.func.isRequired,
  handleProjectTagModalVisible: PropTypes.func.isRequired,
  handleProjectTagCreateCancelClick: PropTypes.func.isRequired,
};

const InnerContainer = styled.div`
  width: 100%;
  max-height: 492px;

  padding: 0px 20px 40px 20px;
  margin-top: -16px;

  overflow-y: scroll;
`;

const TagContainer = styled.div`
  display: flex;
  flex-direction: column;

  margin-bottom: 20px;
`;

const TagText = styled(TX.FootnoteM)`
  display: flex;
  margin-bottom: 20px;

  color: ${({ theme }) => theme.colors.ui_on_3};
`;

const TagItemsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  gap: 20px 8px;
`;

const TagItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  padding: 6px 10px;
  border-radius: 14px;
  cursor: pointer;

  ${({ isSelected, theme }) =>
    isSelected
      ? css`
          border: 1px solid ${theme.colors.primary};
          background-color: ${theme.colors.primary};
        `
      : css`
          border: 1px solid ${theme.colors.ui_3};
        `}
`;

const TagItemText = styled.span`
  ${({ isSelected, theme }) =>
    isSelected
      ? css`
          ${TextCSS.FootnoteB};
          color: ${theme.colors.ui_1};
        `
      : css`
          ${TextCSS.FootnoteM};
          color: ${theme.colors.ui_on_2};
        `}
`;

const BottomContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  position: absolute;
  bottom: 0;

  width: 100%;
  height: 60px;

  gap: 0px 8px;
  padding: 8px 20px 20px 20px;
  border-radius: 0px 0px 14px 14px;
`;

export default ProjectTagModal;
